import React from "react";
import { Panel } from "../../components/ui/primitives";
import MarketIndexCard from "../../features/kquant/components/MarketIndexCard";
import {
  MapFilter,
  MarketHeatmapCard,
  MarketTab,
} from "../../features/kquant/components/MarketHeatmapCard";

export function MarketAnalysisSection({
  marketTab,
  setMarketTab,
  mapFilter,
  setMapFilter,
}: {
  marketTab: MarketTab;
  setMarketTab: (t: MarketTab) => void;
  mapFilter: MapFilter;
  setMapFilter: (v: MapFilter) => void;
}) {
  return (
    <section className="mt-7">
      <Panel className="p-6">
        <div className="flex items-baseline gap-4">
          <div className="text-sm font-semibold">Market Analysis</div>
          <div className="text-xs text-white/55">Understand the Market Structure</div>
        </div>

        <div className="mt-5 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <MarketIndexCard />
          <MarketHeatmapCard
            tab={marketTab}
            setTab={setMarketTab}
            mapFilter={mapFilter}
            setMapFilter={setMapFilter}
          />
        </div>
      </Panel>
    </section>
  );
}
